import BoldButton from "./buttons/bold-button";
import ItalicsButton from "./buttons/italics-button";
import UnderlineButton from "./buttons/underline-button";
import StrikeThroughButton from "./buttons/strike-through-button";
import SmallCapsButton from "./buttons/small-caps-button";
import InlineCodeButton from "./buttons/inline-code-button";
//import GhostButton from "./buttons/ghost-button";
import SpaceTool from "./tools/space-tool";
import LinkTool from "./tools/link-tool";
import SubscriptButton from "./buttons/subscript-button";
import SuperscriptButton from "./buttons/superscript-button";
import CustomLinkTool from "./tools/custom-link-tool";
import FontColorDropdown from "./dropdowns/font-color-dropdown";
import BackgroundColorDropdown from "./dropdowns/background-color-dropdown";
import FontSizeDropdown from "./dropdowns/font-size-dropdown";
import OrderedListTool from "./tools/ordered-list-tool";
import UnorderedListTool from "./tools/unordered-list-tool";
import IndentListButton from "./buttons/indent-list-button";
import OutdentListButton from "./buttons/outdent-list-button";
import BlockquoteButton from "./buttons/blockquote-button";
import OutdentBlockquoteButton from "./buttons/outdent-blockquote-button";
import HorizontalRuleButton from "./buttons/horizontal-rule-button";
import DecoratedHorizontalRuleButton from "./buttons/decorated-horizontal-rule-button";
import HorizontalRuleTool from "./tools/horizontal-rule-tool";
import ParagraphTool from "./tools/paragraph-tool";
import HeadingTool from "./tools/heading-tool";
import EmbedTool from "./tools/embed-tool";
import FigureTool from "./tools/figure-tool";
import PdfTool from "./tools/pdf-tool";
import NotesListTool from "./tools/notes-list-tool";
import QuoteCharTool from "./tools/quote-char-tool";
import DetailsTool from "./tools/details-tool";
import TableTool from "./tools/table-tool";
import TableColumnsTool from "./tools/table-columns-tool";
import TableRowsTool from "./tools/table-rows-tool";
import TableCellsTool from "./tools/table-cells-tool";
import UndoButton from "./buttons/undo-button";
import RedoButton from "./buttons/redo-button";
import { menuPluginKey } from "./menu-plugin";

export default class MenuElement {
  constructor(editorView, editorType) {
    this.view = editorView;
    this.editorType = editorType;
    this.dom = document.createElement("div");
    this.dom.className = "editor-toolbar";
    this.dom.dataset.element = "toolbar";
    this.buildSections();
    this.buildMenu();
    this.parentEditorElement = editorView.dom.closest("richtext-editor");
    this.parentEditorElement.insertBefore(this.dom, this.parentEditorElement.firstElementChild);
  }

  buildSections() {
    this.formatButtons = document.createElement("div");
    this.formatButtons.className = "editor-section";
    this.dom.appendChild(this.formatButtons);

    this.linkButtons = document.createElement("div");
    this.linkButtons.className = "editor-section";
    this.dom.appendChild(this.linkButtons);

    this.scriptButtons = document.createElement("div");
    this.scriptButtons.className = "editor-section";
    this.dom.appendChild(this.scriptButtons);

    this.fontStyleDropdowns = document.createElement("div");
    this.fontStyleDropdowns.className = "editor-section";
    this.dom.appendChild(this.fontStyleDropdowns);

    this.listUtils = document.createElement("div");
    this.listUtils.className = "editor-section";
    this.dom.appendChild(this.listUtils);

    this.blockquoteUtils = document.createElement("div");
    this.blockquoteUtils.className = "editor-section";
    this.dom.appendChild(this.blockquoteUtils);

    this.nodeUtils = document.createElement("div");
    this.nodeUtils.className = "editor-section";
    this.dom.appendChild(this.nodeUtils);

    this.tableUtils = document.createElement("div");
    this.tableUtils.className = "editor-section";
    this.dom.appendChild(this.tableUtils);

    this.historyButtons = document.createElement("div");
    this.historyButtons.className = "editor-section";
    this.dom.appendChild(this.historyButtons);
  }

  buildMenu() {
    this.buttons = [
      new BoldButton(this.view, this.formatButtons),
      new ItalicsButton(this.view, this.formatButtons),
      new UnderlineButton(this.view, this.formatButtons),
      new StrikeThroughButton(this.view, this.formatButtons),
      new SmallCapsButton(this.view, this.formatButtons),
      new InlineCodeButton(this.view, this.formatButtons),
      //new GhostButton(this.view, this.formatButtons),
      new LinkTool(this.view, this.linkButtons),
      new SubscriptButton(this.view, this.scriptButtons),
      new SuperscriptButton(this.view, this.scriptButtons),
      new FontColorDropdown(this.view, this.fontStyleDropdowns),
      new BackgroundColorDropdown(this.view, this.fontStyleDropdowns),
      new FontSizeDropdown(this.view, this.fontStyleDropdowns),
      new OrderedListTool(this.view, this.listUtils),
      new UnorderedListTool(this.view, this.listUtils),
      new IndentListButton(this.view, this.listUtils),
      new OutdentListButton(this.view, this.listUtils),
      new BlockquoteButton(this.view, this.blockquoteUtils),
      new OutdentBlockquoteButton(this.view, this.blockquoteUtils),
      new ParagraphTool(this.view, this.nodeUtils),
      new HeadingTool(this.view, this.nodeUtils),
      new HorizontalRuleTool(this.view, this.nodeUtils),
      //new GhostButton(this.view, this.formatButtons),
      new SpaceTool(this.view, this.formatButtons),
      this.editorType === "basic" ? null : new CustomLinkTool(this.view, this.nodeUtils),
      new EmbedTool(this.view, this.nodeUtils),
      new FigureTool(this.view, this.nodeUtils),
      new PdfTool(this.view, this.nodeUtils),
      this.editorType === "basic" ? null : new NotesListTool(this.view, this.nodeUtils),
      new QuoteCharTool(this.view, this.nodeUtils),
      new TableTool(this.view, this.tableUtils),
      new TableColumnsTool(this.view, this.tableUtils),
      new TableRowsTool(this.view, this.tableUtils),
      new TableCellsTool(this.view, this.tableUtils),
      new UndoButton(this.view, this.historyButtons),
      new RedoButton(this.view, this.historyButtons)
    ].filter(button => button !== null);

    this.tools = this.dom.querySelectorAll("button[aria-expanded]");
  }

  update(view, prevState) {
    const { currentActiveView, currentTool } = menuPluginKey.getState(view.state);

    for(const button of this.buttons) {
      button.update(currentActiveView);
    }

    this.closeInactiveTools(currentTool);

    return true;
  }

  destroy() {
    this.dom.remove();
    this.dom = null;
    this.view = null;

    return true;
  }

  closeInactiveTools(currentTool) {
    let isExpanded;

    this.tools.forEach(toolButton => {
      if(toolButton !== currentTool) {
        toolButton.setAttribute("aria-expanded", "false");
      } else {
        isExpanded = toolButton.getAttribute("aria-expanded") === "true";
        toolButton.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      }
    });
  }
}
